module.exports = __webpack_public_path__ + "img/ejemplo-cedula-frontal.2633ec7f.jpg";